interface TagHeroProps {
  tagName: string;
  articleCount: number;
}

export default function TagHero({ tagName, articleCount }: TagHeroProps) {
  return (
    <section className="relative min-h-[260px] md:min-h-[320px] flex items-end overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-secondary-100/25 to-accent-100/30"></div>

      <div className="relative w-full px-4 md:px-6 pt-24 pb-8 md:pb-10">
        <div className="space-y-3 md:space-y-4">
          <div className="flex items-center gap-3">
            <span className="px-3 py-1.5 rounded-full bg-secondary-500/15 text-secondary-600 text-xs font-semibold whitespace-nowrap">
              标签
            </span>
            <span className="text-xs text-foreground-400 whitespace-nowrap">{articleCount} 篇文章</span>
          </div>
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-900 leading-tight">
            <span className="text-secondary-500">#</span>{tagName}
          </h1>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            浏览所有与 <strong className="text-secondary-600">#{tagName}</strong> 相关的热门资讯和深度爆料
          </p>
        </div>
      </div>
    </section>
  );
}